<template>
  <v-container class="pa-4 pt-1" fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <!-- <v-card class="ma-5" elevation="0"> -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">POA Information</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>

      <!-- แถว 1: Description / Version / Save -->
      <v-row class="mt-2" align="center">
        <v-col cols="12" md="3">
          <v-text-field v-model="description" outlined dense hide-details label="Description"
            ref="description"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="version" outlined dense hide-details label="Version"></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="onClickSave()" width="100" class="buttonblue" color="#112D32">
            Save
          </v-btn>
        </v-col>
      </v-row>

      <!-- แถว 2: Upload File / File Uploaded -->
      <v-row align="center">
        <v-col cols="12" class="d-flex align-center flex-wrap">
          <input type="file" accept="application/pdf,application/vnd.ms-excel" @change="previewMultiImage"
            class="inputsize" ref="filefile" style="display: none" />
          <v-btn :style="{ backgroundColor: '#254E58', color: 'white' }" class="widthbtnimagefile"
            @click="$refs.filefile.click()" elevation="7">
            <v-icon left dark color="white">mdi-cloud-upload</v-icon>
            Upload file
          </v-btn>

          <div v-if="filename.length > 0" class="d-flex align-center flex-wrap ml-8">
            <h5 class="mr-3">File Uploaded:</h5>
            <span v-for="(item, index) in filename" :key="index" class="d-flex align-center mr-4">
              <a @click="popuppreviewfile(index)">{{ item }}</a>
              <v-btn :disabled="sostatus" :style="{ backgroundColor: '#FFEBEE', color: '#F44336' }" small icon
                class="ml-1" @click="popupdeletefile(index)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </span>
          </div>
        </v-col>
      </v-row>

      <br />
      <br />

      <v-card outlined tile>
        <v-data-table :items-per-page-options="pageSizes" :page.sync="page" :items-per-page="itemsPerPage"
          @page-count="pageCount = $event" :search="search" :headers="headers" :items="mDataArray" class="elevation-1"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }">
          <template v-slot:[`item.poafile`]="{ item }">
            <!-- <div
                v-for="file_name_data in item.file_array"
              > -->
            <a class="ml-3" :style="{
              backgroundColor: '#FFEBEE',
              color: '#9E3B1B',
            }" @click="previewnoticefilepdf(item.poafile)">
              {{ item.poafile }}
              <!-- {{ file_name_data}} -->
            </a>
            <br>
            <!-- </div> -->
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon :style="{
              backgroundColor: '#FFEBEE',
              color: '#9E3B1B',
            }" @click="deleteItemTable(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
        <v-progress-linear indeterminate color="teal" v-if="load_bg"></v-progress-linear>
      </v-card>
      <v-dialog v-model="dialogDeleteTable" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteTable">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirmTable">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-dialog v-model="dialogNoFile" max-width="560px" persistent>
      <v-card class="nofile-card">
        <div class="d-flex align-center pa-6 pb-2">
          <div class="nofile-icon">
            <v-icon color="#6D4C1F" size="30">mdi-alert-outline</v-icon>
          </div>
          <span class="nofile-title ml-5">No file uploaded</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogNoFile = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="px-6 pt-2">
          <div class="nofile-text">
            You haven’t uploaded a file yet. Do you want to save this document
            without an attachment?
          </div>
          <div class="nofile-subtext mt-3">You can upload a file later.</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn outlined color="#112D32" class="nofile-btn" @click="goBackToUpload">
            Go back to upload
          </v-btn>
          <v-btn depressed color="#112D32" class="nofile-btn white--text ml-3" @click="saveWithoutFile">
            Save without file
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- </v-card> -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteimage" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this image?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimage">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title>

        <!-- 
                                :src="pdfdata"
                                v-for="i in numPages"
                    :key="i"
                    :id="i"
                    :page="i" -->
        <div v-if="checkfileapreview" v-for="(item, index) in previewpopupfile2" :key="index">
          <pdf :src="item" v-for="i in numPagespreview" :key="i" :id="i" :page="i">
            <template slot="loading">
              loading content here...
            </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title>

        <v-img disabled :src="previewimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewimage">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, POAUrl, } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";
import pdfvuer from "pdfvuer";

export default {
  name: "POA",
  async mounted() {
    this.$showLoader();
    await this.loadData();
    this.$hideLoader();
  },
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      dialogNoFile: false,
      //file
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      //--
      index_del: {},
      dialogDeleteTable: false,
      userId: 0,
      description: "",
      version: "",
      dialogAdd: false,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      load_bg: false,
      isShowPassword: false,
      fullPage: true,
      search: "",
      mDataArray: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_ct: "",
      headers: [
        {
          text: "File",
          value: "poafile",
          class: "bg-colorth",
          divider: true,
          width: "40%",
        },
        {
          text: "Description",
          value: "description",
          class: "bg-colorth",
          divider: true,
          width: "20%",
        },
        {
          text: "Version",
          value: "version",
          class: "bg-colorth",
          divider: true,
          width: "20%",
        },
        {
          text: "Date Upload",
          value: "upload_date",
          class: "bg-colorth",
          divider: true,
          width: "20%",
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth",
          divider: true,
          align: "center",
          width: "70px",
        },
      ],
    };
  },
  methods: {
    onClickSave() {
      if (!this.image_list || this.image_list.length === 0) {
        this.dialogNoFile = true;
        return;
      }
      this.savePOA();
    },
    goBackToUpload() {
      this.dialogNoFile = false;
      this.$nextTick(() => this.$refs.filefile.click());
    },
    async saveWithoutFile() {
      this.dialogNoFile = false;
      await this.savePOA();
    },
    //---------------function file------------//
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      console.log(this.image_list);
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async previewnoticefilepdf(file_name) {
      this.previewpopupfile2 = [];
      console.log(file_name)
      let file_name_s = file_name;
      let pdf_newTab = window.open(
        `${POAUrl}/${this.$route.params.id}/${file_name_s}`
      );

      return;
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
        this.getpreview_list[fileindex] +
        "'></iframe></body></html>"
      );

      return;
      this.previewpopupfile2 = [];
      await this.getPdfforpreview(this.getpreview_list[fileindex]);
      console.log(this.previewpopupfile);
      this.previewpopupfile2 = this.previewpopupfile;
      this.checkfileapreview = true;
      this.dialogpreviewfile = true;
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      this.dialogpreviewimage = true;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      this.imagename = this.image.name;
    },
    async previewMultiImage(event) {
      this.filename = [];
      this.preview_list = [];
      this.getpreview_list = [];
      this.image_list = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_list.push(e.target.result);
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      await this.getPdfforAdd(this.getpreview_list);
      this.preview_list2 = this.preview_list;
      this.image_list.forEach((x) => {
        this.filename.push(x.name);
      });
      this.checkfileeadd = true;
    },
    reset: function () {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
      console.log(this.previewpopupfile);
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    //--------------------end funcfile--------------------//
    async savePOA() {

      let formData = new FormData();
      // formData.append(`file`, this.image);
      this.image_list.forEach((x, index) => {
        formData.append(`file`, x);
      });
      formData.append("contract_id", this.$route.params.id);
      formData.append("description", this.description);
      formData.append("version", this.version);
      formData.append("create_by", localStorage.getItem(server.USER_ID));
      formData.append("update_by", localStorage.getItem(server.USER_ID));
      this.$showLoader();
      const res_add = await api.createPOA(this.$route.params.id, formData)
      if (res_add.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "save data success",
          "text-h5 green--text text-center",
        );
        this.description = "";
        this.version = "";
        this.preview_list2 = [];
        this.getpreview_list = [];
        this.image = null;
        this.previewimage = null;
        this.previewimageedit = null;
        this.image_list = [];
        this.preview_list = [];
        this.dialogpreviewimage = false;
        this.checkfileapreview = false;
        this.previewpopupfile = [];
        this.previewpopupfile2 = [];
        this.dialogpreviewfile = false;
        this.dialogDelete = false;
        this.dialogDeleteimage = false;
        this.filename = [];
        this.imagename = "";
        this.load_bg = false;
        this.checkfileadd = false;
        this.checkimageadd = false;
        await this.loadData();
        this.$hideLoader();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center"
        );
      }
    },
    async loadData() {
      const res_poa = await api.getPOAById(this.$route.params.id)
      this.mDataArray = res_poa.data;
      // this.mDataArray.forEach((item)=>{  
      //   item.file_array = item.poafile.split(',')
      // })
      // console.log(this.mDataArray)
    },
    deleteItemTable(item) {
      this.dialogDeleteTable = true;
      this.index_del = item;
    },
    closeDeleteTable() {
      this.dialogDeleteTable = false;
      this.index_del = 0;
    },
    async deleteItemConfirmTable() {
      this.$showLoader();
      // console.log(this.index_del)
      let file_name = this.index_del.poafile;
      const req_del = await api.deletePOA(this.index_del.id, this.index_del.contract_id, { file_name_del: file_name })
      // console.log(req_del.status)

      if (req_del.status == 200) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "save data success",
          "text-h5 green--text text-center",
        );
        await this.loadData();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center"
        );
      }
      this.closeDeleteTable();
      this.$hideLoader();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.nofile-card {
  border-radius: 14px !important;
}

.nofile-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #f6e3c3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nofile-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #14304a;
}

.nofile-text {
  font-size: 1.05rem;
  color: #1f2937;
  line-height: 1.6;
}

.nofile-subtext {
  font-size: 0.9rem;
  color: #6b7280;
}

.nofile-btn {
  text-transform: none !important;
  font-weight: 600;
  height: 44px !important;
  border-radius: 8px;
}

.poa-btn {
  border: 2px solid #2f4a1f !important;
  border-radius: 12px !important;
  color: #111 !important;
  font-weight: 700;
  font-size: 1rem;
  text-transform: none !important;
  letter-spacing: normal;
}

.file-uploaded {
  font-weight: 700;
  font-size: 1rem;
  color: #111;
}

.file-link {
  color: #111 !important;
  text-decoration: none;
}

.file-link:hover {
  text-decoration: underline;
}
</style>